import { Inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { Config, MW_APP_CONFIG } from '../config';

@Injectable()
export class MwIconLoaderService {
  static nextId = 0;
  id: string = `${
    this.config.environment.clientId
  }-${MwIconLoaderService.nextId++}`;

  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    @Inject(MW_APP_CONFIG) private config: Config
  ) {}

  load(icons: string[]): void {
    icons.forEach((icon) =>
      this.iconRegistry.addSvgIcon(
        icon,
        this.sanitizer.bypassSecurityTrustResourceUrl(
          `assets/icons/${icon}.svg`
        )
      )
    );
  }
}
